import { sendEventAuthorizationError } from 'shared/lib/sendGAEvents';
import { showNotification } from 'shared/lib/showNotification';

import { AuthenticationTexts } from 'features/UpdateContactsInfo/Authentication.texts';

export const onLoginFailed = () => {
  sendEventAuthorizationError('sravni');
};

export const onFailedLoadingUserData = () => {
  showNotification({
    title: AuthenticationTexts.errorTitle,
    subtitle: AuthenticationTexts.errorDescription,
    type: 'error',
  });
};
